import { z } from 'zod';

const RunErrorResponseSchema = z.object({
  payload: z.object({
    errors: z.array(z.string()).optional(),
    message: z.string(),
  }),
});

/**
 * Normalizes a failed run into an error worth showing to the user.
 *
 * The AG-UI transport turns a non-2xx response into `HTTP <status>: <raw body>` and hangs the
 * parsed body off `payload`, which is where the platform's own message and validation errors are.
 */
export function getAgenticChatRunError(error: unknown): Error {
  const response = RunErrorResponseSchema.safeParse(error);
  if (response.success) {
    const { errors, message } = response.data.payload;
    return new Error([message, ...(errors ?? [])].join('\n'));
  }
  return error instanceof Error ? error : new Error(String(error));
}
